// removed by extract-text-webpack-plugin
module.exports = {"root":"expired-slate__root","message":"expired-slate__message","countdown":"expired-slate__countdown"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/expired-slate/styles.less
 ** module id = 425
 ** module chunks = 1
 **/